export default class BestellungQueryRequest {
  id: string
  abgeschlossen: boolean = false
  storniert: boolean = false
  identifier: string
  alter: number = 30
  filialeUrlPath: string
}
